import { path, uniqBy } from 'ramda';

import { sortBasedOnABC } from 'utils/filterOptions';
import { toOptions } from 'utils/toOptions';

import { useSelector } from '../../../../../../hooks';
import {
  useGetAccessedReports,
  useGetAdminReports,
  useGetAdvancedReports,
  useGetBalanceReports,
  useGetServiceDeskReports
} from './useGetAccessedReports';

export const useConcatReportTypes = () => {
  const {
    hasBasicReportAccess,
    hasAdvancedReportAccess,
    hasAdminReportAccess,
    hasBalanceReportAccess,
    hasServiceDeskReportAccess
  } = useSelector(({ grants }) => grants);

  const { data: baseTypes, isFetching: baseIsFetching } =
    useGetAccessedReports(hasBasicReportAccess);
  const { data: advancedTypes, isFetching: advancedIsFetching } =
    useGetAdvancedReports(hasAdvancedReportAccess);
  const { data: adminTypes, isFetching: adminIsFetching } =
    useGetAdminReports(hasAdminReportAccess);
  const { data: balanceTypes, isFetching: balanceIsFetching } =
    useGetBalanceReports(hasBalanceReportAccess);
  const { data: serviceDeskTypes, isFetching: serviceDeskIsFetching } =
    useGetServiceDeskReports(hasServiceDeskReportAccess);

  const baseTypeOptions = toOptions(baseTypes ?? [], 'value', 'label');
  const balanceTypeOptions = toOptions(balanceTypes ?? [], 'value', 'label');
  const advancedTypeOptions = toOptions(advancedTypes ?? [], 'value', 'label');
  const adminTypeOptions = toOptions(adminTypes ?? [], 'value', 'label');
  const serviceDeskOptions = toOptions(
    serviceDeskTypes ?? [],
    'value',
    'label'
  );

  const combinedArray = [
    ...baseTypeOptions,
    ...balanceTypeOptions,
    ...advancedTypeOptions,
    ...adminTypeOptions,
    ...serviceDeskOptions
  ];

  const uniqueArray = uniqBy(path(['label']), combinedArray);

  return {
    isFetching:
      baseIsFetching ||
      advancedIsFetching ||
      adminIsFetching ||
      serviceDeskIsFetching ||
      balanceIsFetching,
    sortedItems: uniqueArray.sort((a, b) => sortBasedOnABC(a, b))
  };
};
